/* tslint:disable */
import {
  Apptype,
  Tenant
} from '../index';

declare var Object: any;
export interface AppInterface {
  apitoken?: string;
  defaulttimezone: string;
  defaultcurrency: string;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  createdAt: Date;
  updatedAt: Date;
  apptypeId?: any;
  tenantId?: any;
  ownerId?: any;
  apptype?: Apptype;
  owner?: Tenant;
  name: string;
}

export class App implements AppInterface {
  apitoken: string;
  defaulttimezone: string;
  defaultcurrency: string;
  lastupdatedby: string;
  createdby: string;
  id: any;
  createdAt: Date;
  updatedAt: Date;
  apptypeId: any;
  tenantId: any;
  ownerId: any;
  apptype: Apptype;
  owner: Tenant;
  name: string;
  constructor(data?: AppInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `App`.
   */
  public static getModelName() {
    return "App";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of App for dynamic purposes.
  **/
  public static factory(data: AppInterface): App{
    return new App(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'App',
      plural: 'apps',
      properties: {
        apitoken: {
          name: 'apitoken',
          type: 'string'
        },
        defaulttimezone: {
          name: 'defaulttimezone',
          type: 'string'
        },
        defaultcurrency: {
          name: 'defaultcurrency',
          type: 'string'
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
        apptypeId: {
          name: 'apptypeId',
          type: 'any'
        },
        tenantId: {
          name: 'tenantId',
          type: 'any'
        },
        ownerId: {
          name: 'ownerId',
          type: 'any'
        },
      },
      relations: {
        apptype: {
          name: 'apptype',
          type: 'Apptype',
          model: 'Apptype'
        },
        owner: {
          name: 'owner',
          type: 'Tenant',
          model: 'Tenant'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/App.ts